<template lang="pug">
.vvvpass
  Breadcrumbs(:list="breadcrumbs")

  template
    img.vvvpass__cover.vvvpass__cover--mobile(src="https://cdn.gaming-goods.com/images/myvvv/myvvvcovermob.webp")
    img.vvvpass__cover.vvvpass__cover--tablet(src="https://cdn.gaming-goods.com/images/myvvv/myvvvcovertab.webp")
    img.vvvpass__cover.vvvpass__cover--desktop(src="https://cdn.gaming-goods.com/images/myvvv/myvvvcoverdesk.webp")

  h1.vvvpass__h1 VVV Season 1

  p.vvvpass__subtitle 23.10.2023 - 21.01.2024

  Button.vvvpass__buy-subscription(is-primary @click="openSubscriptionStore") {{ $t("myVVVBuySubscriptionButton2") }}

  .vvvpass__currency
    Currency.vvvpass__currency-part.vvvpass__currency-part--green(size="24" type="money" is-reversed) 1
    span.vvvpass__currency-part =
    Currency.vvvpass__currency-part(size="24" type="money" real is-reversed) 1

  .vvvpass__points
    .vvvpass__point
      img.vvvpass__point-icon(src="https://cdn.gaming-goods.com/images/vvvpass/vvvpass1.png")
      .vvvpass__point-text {{ $t("vvvpassPoint1") }}
    .vvvpass__point
      img.vvvpass__point-icon(src="https://cdn.gaming-goods.com/images/vvvpass/vvvpass2.png")
      .vvvpass__point-text {{ $t("vvvpassPoint2") }}
    .vvvpass__point
      img.vvvpass__point-icon(src="https://cdn.gaming-goods.com/images/vvvpass/vvvpass3.png")
      .vvvpass__point-text {{ $t("vvvpassPoint3") }}
    .vvvpass__point
      img.vvvpass__point-icon(src="https://cdn.gaming-goods.com/images/vvvpass/vvvpass4.png")
      .vvvpass__point-text {{ $t("vvvpassPoint4") }}
    .vvvpass__point
      img.vvvpass__point-icon(src="https://cdn.gaming-goods.com/images/vvvpass/vvvpass5.png")
      .vvvpass__point-text {{ $t("vvvpassPoint5") }}
    .vvvpass__point
      img.vvvpass__point-icon(src="https://cdn.gaming-goods.com/images/vvvpass/vvvpass6.png")
      .vvvpass__point-text {{ $t("vvvpassPoint6") }}

  .vvvpass__h2(v-t="'prizesAndAwards'")

  .vvvpass__currency
    Currency.vvvpass__currency-part.vvvpass__currency-part--green(size="24" type="money" is-reversed) 1
    span.vvvpass__currency-part =
    Currency.vvvpass__currency-part(size="24" type="money" real is-reversed) 1

  .vvvpass__advantages
    .vvvpass__advantage
      .vvvpass__advantage-text(v-html="$t('vvvpassAdv1')")
      img.vvvpass__advantage-icon(src="https://cdn.gaming-goods.com/images/vvvpass/adv1.png")
    .vvvpass__advantage
      .vvvpass__advantage-text(v-html="$t('vvvpassAdv2')")
      img.vvvpass__advantage-icon(src="https://cdn.gaming-goods.com/images/vvvpass/adv2.png")
    .vvvpass__advantage
      .vvvpass__advantage-text(v-html="$t('vvvpassAdv3')")
      img.vvvpass__advantage-icon(src="https://cdn.gaming-goods.com/images/vvvpass/adv3.png")
    .vvvpass__advantage
      .vvvpass__advantage-text(v-html="$t('vvvpassAdv4')")
      img.vvvpass__advantage-icon(src="https://cdn.gaming-goods.com/images/vvvpass/adv4.png")
    .vvvpass__advantage
      .vvvpass__advantage-text(v-html="$t('vvvpassAdv5')")
      img.vvvpass__advantage-icon(src="https://cdn.gaming-goods.com/images/vvvpass/adv5.png")

  Button.vvvpass__buy-subscription(is-primary @click="openSubscriptionStore") {{ $t("myVVVBuySubscriptionButton2") }}

  template(v-if="tournaments")
    h2.vvvpass__h2(v-t="'upcomingVVVPassTournaments'")

    .vvvpass__tournaments
      TournamentCardNewDesign(v-for="tournament in tournaments" :key="tournament.id" :tournament="tournament" always-short)

    Button.vvvpass__view-all(is-primary @click="openAllVVVPassTournaments") {{ $t("viewAll") }}
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs'
import TournamentCardNewDesign from '~/components/TournamentCard/TournamentCardNewDesign'
import TournamentsService from '~/services/TournamentsService'

export default {
  components: {
    Breadcrumbs,
    TournamentCardNewDesign
  },

  data () {
    return {
      tournaments: undefined
    }
  },

  computed: {
    ...mapState('user', ['user']),

    breadcrumbs () {
      return [
        { title: 'VVV Pass' }
      ]
    }
  },

  mounted () {
    this.findTournaments()
  },

  methods: {
    async findTournaments () {
      const { data } = await TournamentsService.findVVVPassTournaments(this.$axios)
      this.tournaments = data?.data
    },

    openAllVVVPassTournaments () {
      if (this.user?.game_accounts?.length) {
        this.$router.push(this.localeLocation(`/${this.user?.game_accounts[0].game}/tournaments?entry=pass`))
      } else {
        this.$router.push(this.localeLocation('/tournaments?entry=pass'))
      }
    },

    openSubscriptionStore () {
      this.$router.push(this.localeLocation('/store/subscriptions'))
    }
  }
}
</script>

<style lang="scss" scoped>
.vvvpass {
  padding: 16px;

  &__cover {
    width: 100%;
    object-fit: contain;
    display: block;
    margin: 16px 0 8px;

    @media (min-width: $breakpointTablet) {
      margin: 16px 0 40px;
    }

    @media (min-width: $breakpointDesktop) {
      margin: 16px 0 80px;
    }

    &--mobile {
      @media (min-width: $breakpointTablet) {
        display: none;
      }
    }

    &--tablet {
      display: none;

      @media (min-width: $breakpointTablet) {
        display: block;
      }

      @media (min-width: $breakpointDesktop) {
        display: none;
      }
    }

    &--desktop {
      display: none;

      @media (min-width: $breakpointDesktop) {
        display: block;
      }
    }
  }

  &__h1 {
    margin: 0;
    color: $white;
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;

    @media (min-width: $breakpointDesktopWide) {
      font-size: 48px;
      line-height: 52px;
    }
  }

  &__subtitle {
    margin: 8px 0;
    color: $blue-grey10;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  &__buy-subscription {
    width: 100%;

    @media (min-width: $breakpointTablet) {
      width: auto;
      min-width: 316px;
    }
  }

  &__currency {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0 20px;
    padding: 12px 24px;
    border-radius: 8px;
    border: 1px solid $primary60;
    background-color: rgba($primary60, 0.1);
    width: max-content;

    &-part {
      margin-right: 2px;
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      color: $white;

      ::v-deep img {
        path {
          fill: $white;
        }
      }

      &--green {
        color: $green50;

        ::v-deep img {
          path {
            fill: $green50;
          }
        }
      }
    }
  }

  &__points {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    align-items: center;
    margin: 32px 0 40px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 20px;
    }

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &__point {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;
    align-items: center;

    &-icon {
      display: block;
      margin: auto;
      width: 72px;
      height: 72px;
      object-fit: contain;
    }

    &-text {
      color: $white;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
    }
  }

  &__h2 {
    margin: 64px 0 12px;
    color: $white;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;

    @media (min-width: $breakpointDesktopWide) {
      font-size: 32px;
      font-weight: 700;
      line-height: 32px;
    }
  }

  &__tournaments {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 12px;
    margin: 24px 0;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  &__view-all {
    width: 100%;
    margin: 24px 0 64px;
    background: $blue-grey60;

    @media (min-width: $breakpointTablet) {
      width: 316px;
    }
  }

  &__advantages {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 12px;
    margin: 32px 0 20px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 20px;
      margin: 32px 0 40px;
    }

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &__advantage {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 12px;
    align-items: start;
    padding: 24px;
    background: $blue-grey70;
    border-radius: 8px;

    &-text {
      color: $white;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}
</style>
